// import React, {createContext, Dispatch, SetStateAction, useCallback, useState} from "react";
//
// import i18next from "i18next";
// import { I18nextProvider } from "react-i18next";
// import {ConsoleHelper} from "../utils/common";
//
// export declare type BSAppContext = {
//     lang: string | undefined;
//     setLang: Dispatch<SetStateAction<string>>;
// }
//
// export const MyAppContext = createContext<BSAppContext>({
//     lang: i18next.resolvedLanguage,
//     setLang: () => undefined,
// })
//
// const AppContext: React.FC = (props) => {
//     const [lang, setLanguage] = useState<string>(i18next.resolvedLanguage);
//
//     const setLang = (newLang: SetStateAction<string>) => {
//         if (typeof newLang === "string") {
//             updateLang(validateLang(newLang));
//             setLanguage(validateLang(newLang));
//         } else {
//             setLanguage(prevState => {
//                 const l = newLang(prevState);
//                 updateLang(validateLang(l))
//                 return validateLang(l);
//             })
//         }
//     }
//
//     const value = {
//         lang, setLang,
//     }
//
//     const validateLang = useCallback((valLang: string) => {
//         return ["en", "zh-HK", "zh-CN"].find(i18nLang => i18nLang.toLowerCase() === valLang.toLowerCase()) ?? "en";
//     }, [])
//
//     const updateLang = useCallback((newLang: string) => {
//         i18next.changeLanguage(newLang)
//             .then(() => ConsoleHelper("log", "Language changed: ", newLang));
//     }, [])
//
//     return <I18nextProvider i18n={i18next}>
//         <MyAppContext.Provider value={value}>
//         </MyAppContext.Provider>
//     </I18nextProvider>;
//
// }
//
// export default AppContext;
import React, { createContext, Dispatch, SetStateAction, useCallback, useState, useEffect } from "react";
import i18next from "i18next";
import { I18nextProvider, useTranslation } from "react-i18next";
import { ConsoleHelper } from "../utils/common";
import NavStore from "../models/NavStore";

export type BSAppContext = {
    lang: string;
    setLang: Dispatch<SetStateAction<string>>;
    navStore: NavStore;
    setNavStore: Dispatch<SetStateAction<NavStore>>;
}

export const MyAppContext = createContext<BSAppContext>({
    lang: 'en',
    setLang: () => undefined,
    navStore: { history: [], hashHistory: {} },
    setNavStore: () => undefined,
});

// Define props type for AppContext
type AppContextProps = {
    children: React.ReactNode;
}

const AppContext: React.FC<AppContextProps> = ({ children }) => {
    const [lang, setLanguage] = useState<string>(i18next.resolvedLanguage || 'en');
    const [navStore, setNavStore] = useState<NavStore>({ history: [], hashHistory: {} });

    const validateLang = useCallback((valLang: string) => {
        return ["en", "zh-HK", "zh-CN"].find(
            i18nLang => i18nLang.toLowerCase() === valLang.toLowerCase()
        ) ?? "en";
    }, []);

    const updateLang = useCallback((newLang: string) => {
        const validatedLang = validateLang(newLang);
        i18next.changeLanguage(validatedLang)
            .then(() => {
                ConsoleHelper("log", "Language changed: ", validatedLang);
                setLanguage(validatedLang);
            });
    }, [validateLang]);

    useEffect(() => {
        updateLang(lang);
    }, [lang, updateLang]);

    const setLang = (newLang: SetStateAction<string>) => {
        if (typeof newLang === "string") {
            updateLang(validateLang(newLang));
            setLanguage(validateLang(newLang));
        } else {
            setLanguage(prevState => {
                const l = newLang(prevState);
                updateLang(validateLang(l))
                return validateLang(l);
            })
        }
    }

    const value = {
        lang, setLang,
        navStore, setNavStore,
    };

    return (
        <I18nextProvider i18n={i18next}>
            <MyAppContext.Provider value={value}>
                {children}
            </MyAppContext.Provider>
        </I18nextProvider>
    );
};

export default AppContext;

declare module 'react-i18next' {
    interface I18nextProviderProps {
        children?: React.ReactNode;
    }
}